import { Component, OnInit, ViewChild, ElementRef } from '@angular/core'
import { FormGroup, FormControl, Validators } from '@angular/forms'
import {
  KcDataService
} from '../../kc-data.service'
import {
  CptSharedDataService,
  TransifexService
} from '@inside-hub-app/customer-portal-shared'
import {
  B2CConfig,
  Country
} from '@inside-hub-app/customer-portal-config'
import { KcCompanyRequestChangeViewData, KcClientData, KcRealmData } from '../../interfaces/kc-data.interface'
import { BreakpointObserver } from '@angular/cdk/layout'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
@Component({
  selector: 'customer-portal-kc-company-request-change',
  templateUrl: './kc-company-request-change.component.html',
  styleUrls: ['./kc-company-request-change.component.scss']
})
export class KcCompanyRequestChangeComponent implements OnInit {
  companyNameRegex: string
  addressStreetRegex: string
  addressZipRegex: string
  addressCityRegex: string

  constructor (
    private readonly kcDataService: KcDataService,
    private readonly kcSharedDataService: CptSharedDataService,
    public breakpointObserver: BreakpointObserver,
    public transifexService: TransifexService,
    public remoteConfigService: EfRemoteConfigurationService<B2CConfig>
  ) {
    this.companyNameRegex = this.remoteConfigService.get(
      'regEx.addressRegEx.companyName.pattern'
    )
  
    this.addressStreetRegex = this.remoteConfigService.get(
      'regEx.addressRegEx.street.pattern'
    )
  
    this.addressZipRegex = this.remoteConfigService.get(
      'regEx.addressRegEx.zip.pattern'
    )
  
    this.addressCityRegex = this.remoteConfigService.get(
      'regEx.addressRegEx.city.pattern'
    )
    this.countries = this.remoteConfigService.getArrayValues<Country[]>('countries')

    this.form = new FormGroup({
      companyName: new FormControl<string | null>(
        null,
        Validators.compose([Validators.pattern(this.companyNameRegex)])
      ),
      address: new FormControl<string | null>(
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern(this.addressStreetRegex),
          Validators.maxLength(
            this.remoteConfigService.get('regEx.addressRegEx.street.maxLength')
          )
        ])
      ),
      companyNumber: new FormControl<string | null>(null),
      zip: new FormControl<string | null>(
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern(this.addressZipRegex),
          Validators.minLength(
            this.remoteConfigService.get('regEx.addressRegEx.zip.minLength')
          ),
          Validators.maxLength(
            this.remoteConfigService.get('regEx.addressRegEx.zip.maxLength')
          )
        ])
      ),
      city: new FormControl<string | null>(
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern(this.addressCityRegex),
          Validators.maxLength(
            this.remoteConfigService.get('regEx.addressRegEx.city.maxLength')
          )
        ])
      ),
      country: new FormControl<string | null>(null, Validators.required),
      action: new FormControl<string | null>(null)
    })
  }

  @ViewChild('companyRequestChangeForm', { static: true })
  private readonly formRef: ElementRef

  public form

  private readonly logo = 'assets/images/ef-logo-blue.svg'
  private readonly background = 'assets/background_login.jpg'

  public realmData: KcRealmData
  public clientData: KcClientData
  public viewData: KcCompanyRequestChangeViewData
  public logoUrl: string
  public backgroundUrl: string
  public color: string
  public vpn = 'assets/icons/vpn_key_24px.svg'
  public vpnUrl: string
  public emailImage = 'assets/icons/alternate_email_24px.svg'
  public emailImageUrl: string
  countries

  ngOnInit () {
    const layoutChanges = this.breakpointObserver.observe([
      '(min-width: 1124px)'
    ])
    layoutChanges.subscribe(data => {
      this.color = data.matches ? 'white' : 'primary'
      this.backgroundUrl = data.matches
        ? `${this.kcSharedDataService.getResourcesPath()}/${this.background}`
        : ''
    })

    this.vpnUrl = `${this.kcSharedDataService.getResourcesPath()}/${this.vpn}`
    this.emailImageUrl = `${this.kcSharedDataService.getResourcesPath()}/${
      this.emailImage
    }`

    this.logoUrl = `${this.kcSharedDataService.getResourcesPath()}/${this.logo}`
    this.realmData = this.kcDataService.getRealmData()
    this.clientData = this.kcDataService.getClientData()
    this.viewData =
      this.kcDataService.getViewData() as KcCompanyRequestChangeViewData

    // // set initial values
    this.form.patchValue({
      companyName: this.viewData.formData.companyName || '',
      companyNumber: this.viewData.formData.companyNumber || '',
      address: this.viewData.formData.address || '',
      zip: this.viewData.formData.zip || '',
      city: this.viewData.formData.city || '',
      country: this.viewData.formData.country || ''
    })
  }

  public login () {
    // submit form
    const formElement = this.formRef.nativeElement as HTMLFormElement
    formElement.submit()
  }
}
